import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, Input, Text } from '@match/react-component-library';

const { SEMANTIC_COLOR_NAME, SPACE } = constants;

interface NameInputProps {
  nameInput: string | undefined;
  nameInputError: boolean;
  onNameInputAdd: (event: React.ChangeEvent<HTMLInputElement> | undefined) => void;
}

export const NameInput: React.FunctionComponent<NameInputProps> = ({
  nameInput,
  nameInputError,
  onNameInputAdd,
}) => {
  const intl = useIntl();

  return (
    <Box marginBottom={SPACE.XLARGE}>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.name} />
      </Box>
      <Input
        onChange={onNameInputAdd}
        placeholder={intl.formatMessage(messages.name)}
        value={nameInput}
        width="100%"
      />
      <div>
        {nameInputError && (
          <Text color={SEMANTIC_COLOR_NAME.ERROR}>
            <FormattedMessage {...messages.nameErrorText} />
          </Text>
        )}
      </div>
    </Box>
  );
};

const messages = defineMessages({
  name: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/NameInput/NameInput:name',
    description: 'name input placeholder',
    defaultMessage: 'Name',
  },
  nameErrorText: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/NameInput/NameInput:nameErrorText',
    description: 'name error text',
    defaultMessage: 'Please provide your name',
  },
});
